// extracted by mini-css-extract-plugin
export default {"loader":"PageLoader_loader__Mi0uz"};